import React from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';
import { useMatchBreakpoint } from '@hivebrite/design-system/Theme';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

interface CreateEditLayoutProps {
  children: React.ReactElement;
}

const CreateEditLayout = ({ children }: CreateEditLayoutProps) => {
  const isMobile: boolean = useMatchBreakpoint(['s']);

  return (
    <Container>
      <Grid width="100%" mx={isMobile ? 0 : undefined}>
        <Row>
          <Col offset={{ _: 0, m: 2 / 12 }} width={{ _: 1, m: 8 / 12 }}>
            <Box display="block" mt={{ _: 0, m: 6 }} mb={{ _: 0, m: 18 }}>
              {children}
            </Box>
          </Col>
        </Row>
      </Grid>
    </Container>
  );
};

export default CreateEditLayout;
